import { useSelector } from "react-redux";
import { UTMCampaign, UTMContent, UTMMedium, UTMSource, UTMTerm } from "./components";
import { UTMOverall } from "./components";
import { selectLogInUsername } from "../../common/authenticateDashboard/authSlice";


const MarketingPerformance = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  return (
    <div className="flex-grow" >
      <div className="my-3 p-3 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <UTMSource />
            <UTMMedium />
            <UTMCampaign />
            <UTMContent />
            <UTMTerm/>
           <UTMOverall />
        </div>
      </div>
    </div>
  );
};

export default MarketingPerformance;
